var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({staticStyle:{"border-width":"2px"},attrs:{"color":_vm.color,"outlined":""}},'v-chip',_vm.$attrs,false),[_c('span',{staticClass:"font-weight-black"},[_vm._v(_vm._s(_vm.estado))])])
}
var staticRenderFns = []

export { render, staticRenderFns }